import * as React from "react";
import { styled, Theme, CSSObject } from "@mui/material/styles";
import { Autocomplete, Box, Collapse, Divider, Menu, MenuItem, TextField, Tooltip } from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import styles from "../../../assets/styles/componentStyles/sideNavigationPanel.module.scss";
import { Grid } from "@mui/material";
import chronoxLogo from "../../../assets/images/global/ChronoxLogoSVG.svg";
import { useNavigate } from "react-router";
import { SidepanelAccountDetails } from "../../utility/sidePanelAccountDetails";
import { UserContext, UserContextPayload } from "../../../context/userContext";
import shortChronoxLogo from "../../../assets/images/global/Chronox AI Icon.svg";
import globalStyles from "../../../assets/styles/global.module.scss";
import { makeStyles, withStyles } from '@mui/styles';
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { useSearchParams } from "react-router-dom";
import IconsColor from "../../utility/iconsColor";
import { getOrganizationDetailDataModel } from "../../../models/axiosModel";
import { DelegateAccess } from "../../global/delegateAccess";
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import BackToMainPageGlobalComponent from "../../utility/backToMainPageGlobalComponent";
import { flagShowGetStartedPage, getMenuNameOfMainMenu, isGetStartedPageActive, isStagingEnv, showWorkspaceBlock, sideNavigationNavigateToHomeBlockedRoutes, sidePanelWidth } from "../../../utils/constants";
import { primaryColor, tertiaryColor } from "../../../utils/colors";
import { getSideNavigationPanelMaxHeightClassName, isNewTabClick } from "./constant";
import { getVendorField } from "../../../utils/whiteLabelling"; 

const mobileDrawerWidth = "70px !important";
const openedMixin = (theme: Theme): CSSObject => ({
    width: sidePanelWidth,
    zIndex: 1,
    transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
    }),
    overflow: "hidden"
});

const closedMixin = (theme: Theme): CSSObject => ({
    transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
    }),
    overflow: "hidden",
    // width: `calc(${theme.spacing(7)} + 1px)`,
    width: mobileDrawerWidth,
    zIndex: 1,
    [theme.breakpoints.up("sm")]: {
        width: `calc(${theme.spacing(8)} + 1px)`
    }
});

const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar
}));

interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
}

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open"
})<AppBarProps>(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
    }),
    ...(open && {
        marginLeft: sidePanelWidth,
        width: `calc(100% - ${sidePanelWidth}px)`,
        transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        })
    })
}));

const Drawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== "open"
})(({ theme, open }) => ({
    width: sidePanelWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    ...(open && {
        ...openedMixin(theme),
        "& .MuiDrawer-paper": openedMixin(theme)
    }),
    ...(!open && {
        ...closedMixin(theme),
        "& .MuiDrawer-paper": closedMixin(theme)
    })
}));

export default function MiniDrawer(props: any) {
    const navigate = useNavigate()
    const [open, setOpen] = React.useState(true);
    const [hoveredMenu, setHoveredMenu] = React.useState("");
    const { userDetail, organizationDetails, setCurrentActiveMenu, customPagesData, selectedSubMenu, setSelectedSubMenu, currentMenuName, setCurrentMenuName, flagHideConsultation, vendorData } = React.useContext(UserContext) as UserContextPayload;
    const [tooltipClickedMenu, setTooltipClickedMenu] = React.useState("")
    const [currentSubMenuName, setCurrentSubMenuName] = React.useState("");
    const [searchParams, setSearchParams] = useSearchParams();
    const chatbot_id = searchParams.get("chatbot_id");
    const id = searchParams.get("id");
    const agentId = searchParams.get("voice_agent_id");
    const organization_id = searchParams.get('organization_id');
    const pathName = window.location.pathname.toLowerCase()

    const [openMenu, setOpenMenu] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClickWorkspace = (event: any) => {
        setAnchorEl(event.currentTarget);
        setOpenMenu(true);
    };
    const handleClose = () => {
        setAnchorEl(null);
        setOpenMenu(false);
    };

    React.useEffect(() => {
        // Tim Safransky's Organization ID
        // userDetail?.user_organization_data?.organization_id != 2582
        if (window.location.pathname == "/" && userDetail?.user_organization_data?.organization_id != 2645 && userDetail?.user_organization_data?.organization_id != 2569) {
            // setCurrentMenuName("chatbot")
            // setCurrentSubMenuName("");
            // setCurrentActiveMenu("/chatbot") 

            // setOpen(true);
            // setCurrentMenuName("campaign");
            // setCurrentSubMenuName("whatsappCampaign");
            // setCurrentActiveMenu(`/whatsappcampaign`); 
            if(flagShowGetStartedPage(userDetail)){ 
                setCurrentMenuName("get-started")
                setCurrentSubMenuName("");
                setCurrentActiveMenu("/get-started")
            } else {
                setCurrentMenuName("dashboard")
                setCurrentSubMenuName("");
                setCurrentActiveMenu("/dashboard")
            }
        }
        else if (window.location.pathname == "/" && userDetail?.user_organization_data?.organization_id == 2645) {  //activemenu for aapdujunagadh
            setCurrentMenuName("channels")
            setCurrentSubMenuName("");
            setCurrentActiveMenu("/channels")
        }
        // else if (window.location.pathname == "/" && userDetail?.user_organization_data?.organization_id == 2582) {  //active menu for timsafransky
        //     setOpen(true);
        //     setCurrentMenuName("callanalysis");
        //     setCurrentSubMenuName("dashboard");
        //     setCurrentActiveMenu(`/callanalysis`)
        // } 
        else if (window.location.pathname == "/" && userDetail?.user_organization_data?.organization_id == 2569) {  //active menu for Mawhiba
            setOpen(true);
            setCurrentMenuName("campaign");
            setCurrentSubMenuName("whatsappCampaign");
            setCurrentActiveMenu(`/whatsappcampaign`); 
        }
        else if (window.location.pathname.toLowerCase() == "/createchatbot" || window.location.pathname.toLowerCase() === "/chatbot") {
            setCurrentMenuName("chatbot")
            setCurrentSubMenuName("");
            setCurrentActiveMenu("/chatbot")
        } 
        else if (window.location.pathname == "/get-started") {
            setCurrentMenuName("get-started")
            setCurrentSubMenuName("");
            setCurrentActiveMenu("/get-started")
        }
        else if (window.location.pathname == "/insights") {
            setCurrentMenuName("home")
            setCurrentSubMenuName("");
            setCurrentActiveMenu("/insights")
        }
        else if (window.location.pathname.toLowerCase() === "/inbox") {
            setCurrentMenuName("inbox");
            setCurrentSubMenuName("");
            setCurrentActiveMenu(`/inbox`)
        }
        else if (window.location.pathname.toLowerCase() === "/voiceagent") {
            setCurrentMenuName("voiceagent");
            setCurrentSubMenuName("");
            setCurrentActiveMenu(`/voiceagent`)
        }
        else if (window.location.pathname.toLowerCase() === "/voiceagent/createvoiceagent") {
            setCurrentMenuName("voice_agent_details");
            setCurrentSubMenuName("");
            setCurrentActiveMenu(agentId ? `/voiceagent/createvoiceagent?voice_agent_id=${agentId}` : `/voiceagent/createvoiceagent`)
        }
        else if (window.location.pathname.toLowerCase() === "/voiceagent/createvoiceagent/deployments") {
            setCurrentMenuName("deployments");
            setCurrentSubMenuName("");
            setCurrentActiveMenu(agentId ? `/voiceagent/createvoiceagent/deployments?voice_agent_id=${agentId}` : `/voiceagent/createvoiceagent/deployments`)
        }
        else if (window.location.pathname.toLowerCase() === "/voiceagent/createvoiceagent/customapi") {
            setCurrentMenuName("voice_agent_custom_api");
            setCurrentSubMenuName("");
            setCurrentActiveMenu(agentId ? `/voiceagent/createvoiceagent/customapi?voice_agent_id=${agentId}` : `/voiceagent/createvoiceagent/customapi`)
        }
        else if (window.location.pathname.toLowerCase() === "/dashboard") {
            setCurrentMenuName("dashboard");
            setCurrentSubMenuName("");
            setCurrentActiveMenu(`/dashboard`)
        }
        else if (window.location.pathname.toLowerCase() === "/supportticket") {
            setOpen(true);
            setCurrentMenuName("showMoreLess");
            setCurrentSubMenuName("supportTicket");
            setCurrentActiveMenu(`/supportTicket`)
        }
        else if (window.location.pathname.toLowerCase() == "/contacts") {
            setOpen(true);
            setCurrentMenuName("showMoreLess");
            setCurrentSubMenuName("contacts");
            setCurrentActiveMenu(`/contacts`)
        }
        else if (window.location.pathname.toLowerCase() == "/product") {
            setOpen(true);
            setCurrentMenuName("showMoreLess");
            setCurrentSubMenuName("Product");
            setCurrentActiveMenu(`/product`)
        } 
        else if (window.location.pathname.toLowerCase() === "/knowledge-base") {
            setOpen(true);
            setCurrentMenuName("showMoreLess");
            setCurrentSubMenuName("knowledgeBase");
            setCurrentActiveMenu("/knowledgeBase");
        }
        else if (window.location.pathname.toLowerCase() === "/channels") {
            setOpen(true);
            setCurrentMenuName("showMoreLess");
            setCurrentSubMenuName("channels");
            setCurrentActiveMenu(`/channels`)
        }
        else if (window.location.pathname.toLowerCase() === "/analytics") {
            setCurrentMenuName("analytics");
            setCurrentSubMenuName("");
            setCurrentActiveMenu(`/analytics`)
        }
        else if (window.location.pathname.toLowerCase() === "/whatsappcampaign" || window.location.pathname.toLowerCase() === "/whatsappcampaign/createnewcampaign") {
            setOpen(true);
            setCurrentMenuName("campaign");
            setCurrentSubMenuName("whatsappCampaign");
            setCurrentActiveMenu(`/whatsappcampaign`)
        }
        else if (window.location.pathname.toLowerCase() === "/whatsappcampaign/dashboard") {
            setOpen(true);
            setCurrentMenuName("campaign");
            setCurrentSubMenuName("whatsappCampaignDashboard");
            setCurrentActiveMenu(`/whatsappCampaignDashboard`);
        }
        else if (window.location.pathname.toLowerCase() === "/workflow" || window.location.pathname.toLowerCase() === "/workflow/staticworkflowdetails") {
            setCurrentMenuName("workFlow");
            setCurrentSubMenuName("");
            setCurrentActiveMenu("/workflow");
        }
        else if (window.location.pathname.toLowerCase() === "/customapi") {
            setOpen(true);
            setCurrentMenuName("showMoreLess");
            setCurrentSubMenuName("customAPI");
            setCurrentActiveMenu("/customAPI");
        }
        else if (window.location.pathname.toLowerCase() === "/customapi/createcustomapi") {
            // setCurrentMenuName("customAPI");
            // setCurrentSubMenuName("");
            // setCurrentActiveMenu("/customAPI"); 
            setOpen(true);
            setCurrentMenuName("showMoreLess");
            setCurrentSubMenuName("customAPI");
            setCurrentActiveMenu("/customAPI");
        } 
        else if (window.location.pathname.toLowerCase() === "/webhook") {
            setOpen(true);
            setCurrentMenuName("showMoreLess");
            setCurrentSubMenuName("Webhook");
            setCurrentActiveMenu("/Webhook");
        }
        else if (window.location.pathname.toLowerCase() === "/intent") {
            setOpen(true);
            setCurrentMenuName("showMoreLess");
            setCurrentSubMenuName("Intent");
            setCurrentActiveMenu("/intent");
        }
        else if (window.location.pathname.toLowerCase() === "/orderdetails") {
            setCurrentMenuName("orderDetails");
            setCurrentSubMenuName("");
            setCurrentActiveMenu(`/orderDetails`)
        }
        else if (window.location.pathname.toLowerCase() === "/conversionleads") {
            setCurrentMenuName("conversionLeads");
            setCurrentSubMenuName("");
            setCurrentActiveMenu(`/conversionLeads`)
        }
        else if (window.location.pathname.toLowerCase() == "/campaigns/create") {
            setCurrentActiveMenu("/campaigns")
        }
        else if (window.location.pathname.toLowerCase() == "/customtemplate") {
            setCurrentActiveMenu("/templates")
        }
        else if (window.location.pathname.toLowerCase() === "/settings-plansandbilling") {
            setCurrentActiveMenu("/settings-accountDetails")
        }
        else if (window.location.pathname.toLowerCase() === "/settings-accountdetails") {
            setCurrentActiveMenu("/settings-accountDetails")
        }
        else if (window.location.pathname.toLowerCase() === "/chatbot/viewchatbot/basicdetail" || window.location.pathname.toLowerCase() === "/chatbot/viewchatbot") {
            setCurrentMenuName("basic_details");
            setCurrentSubMenuName("");
            setCurrentActiveMenu(`/chatbot/viewchatbot/basicdetail?chatbot_id=${chatbot_id}`)
        }
        else if (window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/integration/slack" || window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/integration/zoho" || window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/integration/customapi" || window.location.pathname == "/chatbot/viewchatbot/integration/calendly/selectCalendlyEvent" || window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/integration/whatsapp" || window.location.pathname.toLowerCase() === "/chatbot/viewchatbot/integration" || window.location.pathname.toLowerCase() === "/chatbot/viewchatbot/integration/calendly" || window.location.pathname.toLowerCase() === "/chatbot/viewchatbot/integration/calendly" || window.location.pathname.toLowerCase() == "/chatbot/viewchatbot/integration/createcustomapi") {
            setCurrentMenuName("data_connector");
            setCurrentSubMenuName("");
            setCurrentActiveMenu(`/chatbot/viewchatbot/integration?chatbot_id=${chatbot_id}`)
        }
        else if (window.location.pathname.toLowerCase() === "/chatbot/viewchatbot/subaichatbot") {
            setCurrentMenuName("sub_ai_chatbot");
            setCurrentSubMenuName("");
            setCurrentActiveMenu(`/chatbot/viewchatbot/subaichatbot?chatbot_id=${chatbot_id}`)
        }
        else if (window.location.pathname.toLowerCase() === "/chatbot/viewchatbot/persistentmenu") {
            setCurrentMenuName("persistent_menu");
            setCurrentSubMenuName("");
            setCurrentActiveMenu(`/chatbot/viewchatbot/persistentmenu?chatbot_id=${chatbot_id}`)
        }
        else if (window.location.pathname.toLowerCase() === "/chatbot/viewchatbot/channels/whatsapp" || window.location.pathname.toLowerCase() === "/chatbot/viewchatbot/channels/viewwhatsappintegration") {
            setOpen(true);
            setCurrentMenuName("channels");
            setCurrentSubMenuName("whatsapp");
            setCurrentActiveMenu(`/chatbot/viewchatbot/channels/whatsapp?chatbot_id=${chatbot_id}`)
        }
        else if (window.location.pathname.toLowerCase() === "/chatbot/viewchatbot/channels/facebook" || window.location.pathname.toLowerCase() === "/chatbot/viewchatbot/channels/viewfacebookintegration") {
            setOpen(true);
            setCurrentMenuName("channels");
            setCurrentSubMenuName("facebook");
            setCurrentActiveMenu(`/chatbot/viewchatbot/channels/facebook?chatbot_id=${chatbot_id}`)
        }
        else if (window.location.pathname.toLowerCase() === "/chatbot/viewchatbot/channels/instagram" || window.location.pathname.toLowerCase() === "/chatbot/viewchatbot/channels/viewinstagramintegration") {
            setOpen(true);
            setCurrentMenuName("channels");
            setCurrentSubMenuName("instagram");
            setCurrentActiveMenu(`/chatbot/viewchatbot/channels/instagram?chatbot_id=${chatbot_id}`)
        }
        else if (window.location.pathname.toLowerCase() === "/chatbot/viewchatbot/channels/website") {
            setOpen(true);
            setCurrentMenuName("channels");
            setCurrentSubMenuName("website");
            setCurrentActiveMenu(`/chatbot/viewchatbot/channels/website?chatbot_id=${chatbot_id}`)
        }
        else if (window.location.pathname.toLowerCase().includes("/chatbot/viewchatbot/channels/calendly")) {
            setOpen(true);
            setCurrentMenuName("channels");
            setCurrentSubMenuName("calendly");
            setCurrentActiveMenu(`/chatbot/viewchatbot/channels/calendly?chatbot_id=${chatbot_id}`)
        }
        else if (window.location.pathname.toLowerCase().includes("/chatbot/viewchatbot/channels/slack")) {
            setOpen(true);
            setCurrentMenuName("channels");
            setCurrentSubMenuName("slack");
            setCurrentActiveMenu(`/chatbot/viewchatbot/channels/slack?chatbot_id=${chatbot_id}`)
        }
        // else if (window.location.pathname.toLowerCase().includes("/chatbot/viewchatbot/channels/zoho")) {
        //     setOpen(true);
        //     setCurrentMenuName("channels");
        //     setCurrentSubMenuName("zoho");
        //     setCurrentActiveMenu(`/chatbot/viewchatbot/channels/zoho?chatbot_id=${chatbot_id}`)
        // }
        else if (window.location.pathname.toLowerCase() === "/chatbot/viewchatbot/messageformat" || window.location.pathname.toLowerCase() === "/chatbot/viewchatbot/messageformat/staticformat") {
            setCurrentMenuName("message_format");
            setCurrentSubMenuName("");
            setCurrentActiveMenu(`/chatbot/viewchatbot/messageformat?chatbot_id=${chatbot_id}`)
        }
        else if (window.location.pathname.toLowerCase() === "/chatbot/viewchatbot/trychatbot") {
            setCurrentMenuName("try_chatbot");
            setCurrentSubMenuName("");
            setCurrentActiveMenu(`/chatbot/viewchatbot/trychatbot?chatbot_id=${chatbot_id}`)
        }
        else if (window.location.pathname.toLowerCase() === "/chatbot/viewchatbot/leadgeneration" || window.location.pathname.toLowerCase() === "/chatbot/viewchatbot/leadgeneration/createleadgeneration" || window.location.pathname.toLowerCase() === "/chatbot/viewchatbot/leadgeneration/email" || window.location.pathname.toLowerCase() === "/chatbot/viewchatbot/leadgeneration/spreadsheet" || window.location.pathname.toLowerCase() === "/chatbot/viewchatbot/leadgeneration/slack") {
            setCurrentMenuName("leadgeneration");
            setCurrentSubMenuName("");
            setCurrentActiveMenu(`/chatbot/viewchatbot/leadgeneration?chatbot_id=${chatbot_id}`)
        }
        else if (window.location.pathname.toLowerCase() === "/chatbot/viewchatbot/products") {
            setCurrentMenuName("products");
            setCurrentSubMenuName("");
            setCurrentActiveMenu(`/chatbot/viewchatbot/products?chatbot_id=${chatbot_id}`);
        }
        else if (window.location.pathname.toLowerCase() === "/chatbot/viewchatbot/inbox") {
            setCurrentMenuName("inbox");
            setCurrentSubMenuName("");
            setCurrentActiveMenu(`/chatbot/viewchatbot/inbox?chatbot_id=${chatbot_id}`)
        }

        else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/whatsapp") {
            setOpen(true);
            setCurrentMenuName("account");
            // setCurrentSubMenuName("");
            id ? setCurrentActiveMenu(`/channels/viewintegration/whatsapp?id=${id}`) : setCurrentActiveMenu(`/channels/viewintegration/whatsapp`)
        }
        else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/whatsapp/flows" || window.location.pathname.toLowerCase() === "/channels/viewintegration/whatsapp/flowdetails") {
            setOpen(true);
            setCurrentMenuName("templateflow");
            // setCurrentSubMenuName("");
            id ? setCurrentActiveMenu(`/channels/viewintegration/whatsapp/flows?id=${id}`) : setCurrentActiveMenu(`/channels/viewintegration/whatsapp/flows`)
        }
        else if(window.location.pathname.toLowerCase() == "/channels/viewintegration/whatsapp/paymentconfiguration") {
            setOpen(true);
            setCurrentMenuName("paymentconfiguration");
            id ? setCurrentActiveMenu(`/channels/viewintegration/whatsapp/paymentconfiguration?id=${id}`) : setCurrentActiveMenu(`/channels/viewintegration/whatsapp/paymentconfiguration`)
        }
        else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/whatsapp/carouseltemplategroups") {
            setOpen(true);
            setCurrentMenuName("templatemessage");
            // setCurrentSubMenuName("");
            id ? setCurrentActiveMenu(`/channels/viewintegration/whatsapp/carouseltemplategroups?id=${id}`) : setCurrentActiveMenu(`/channels/viewintegration/whatsapp/carouseltemplategroups`)
        }

        else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/whatsapp/phonenumbers" || window.location.pathname.toLowerCase() === "/channels/viewintegration/whatsapp/phonenumbers/customrecipient") {
            setOpen(true);
            setCurrentMenuName("phonenumbers");
            // setCurrentSubMenuName("");
            id ? setCurrentActiveMenu(`/channels/viewintegration/whatsapp/phonenumbers?id=${id}`) : setCurrentActiveMenu(`/channels/viewintegration/whatsapp/phonenumbers`)
        }
        else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/whatsapp/legacy/templateinfo" || window.location.pathname.toLowerCase() === "/channels/viewintegration/whatsapp/templatemessages") {
            setCurrentMenuName("templatemessage");
            // setCurrentSubMenuName("");
            id ? setCurrentActiveMenu(`/channels/viewintegration/whatsapp/templatemessages?id=${id}`) : setCurrentActiveMenu(`/channels/viewintegration/whatsapp/templatemessages`)
        }
        else if (window.location.pathname.toLowerCase().startsWith("/channels/viewintegration/whatsapp/templatelibrary")) {
            setCurrentMenuName("templatemessage");
            // setCurrentSubMenuName("");
            id ? setCurrentActiveMenu(`/channels/viewintegration/whatsapp/templatelibrary?id=${id}`) : setCurrentActiveMenu(`/channels/viewintegration/whatsapp/templatelibrary`)
        }

        else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/facebook") {
            setCurrentMenuName("accountfacebook");
            id ? setCurrentActiveMenu(`/channels/viewintegration/facebook?id=${id}`) : setCurrentActiveMenu(`/channels/viewintegration/facebook`)
        }
        else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/facebook/pages") {
            setCurrentMenuName("pages");
            id ? setCurrentActiveMenu(`/channels/viewintegration/facebook/pages?id=${id}`) : setCurrentActiveMenu(`/channels/viewintegration/facebook/pages`)
        }
        else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/facebook/templateinfo" || window.location.pathname.toLowerCase() === "/channels/viewintegration/facebook/templatemessages") {
            setCurrentMenuName("templatemessagefacebook");
            id ? setCurrentActiveMenu(`/channels/viewintegration/facebook/templatemessages?id=${id}`) : setCurrentActiveMenu(`/channels/viewintegration/facebook/templatemessages`)
        }

        else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/instagram") {
            setCurrentMenuName("accountInstagram");
            id ? setCurrentActiveMenu(`/channels/viewintegration/instagram?id=${id}`) : setCurrentActiveMenu(`/channels/viewintegration/instagram`)
        }
        else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/slack") {
            setCurrentMenuName("accountslack");
            id ? setCurrentActiveMenu(`/channels/viewintegration/slack?id=${id}`) : setCurrentActiveMenu(`/channels/viewintegration/slack`)
        }
        else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/slack/channels") {
            setCurrentMenuName("slackchannels");
            id ? setCurrentActiveMenu(`/channels/viewintegration/slack/channels?id=${id}`) : setCurrentActiveMenu(`/channels/viewintegration/slack/channels`)
        }
        else if (window.location.pathname.toLowerCase() === "/channels/viewintegration/zoho") {
            setCurrentMenuName("accountZoho");
            id ? setCurrentActiveMenu(`/channels/viewintegration/zoho?id=${id}`) : setCurrentActiveMenu(`/channels/viewintegration/zoho`)
        }
        else if (window.location.pathname.toLowerCase() === "/organization") {
            setCurrentMenuName("workspace");
            // setCurrentSubMenuName("");
            setCurrentActiveMenu(organization_id ? `/organization?organization_id=${organization_id}` : `/organization`)
        }
        else if (window.location.pathname.toLowerCase() === "/organization/ticketsubstatus") {
            setCurrentMenuName("ticketsubstatus");
            // setCurrentSubMenuName("");
            setCurrentActiveMenu(organization_id ? `/organization/ticketSubstatus?organization_id=${organization_id}` : `/organization`)
        }
        else if (window.location.pathname.toLowerCase() === "/organization/teams") {
            setCurrentMenuName("teams");
            setCurrentActiveMenu(organization_id ? `/organization/teams?organization_id=${organization_id}` : `/organization/teams`)
        }
        else if (window.location.pathname.toLowerCase() === "/apikeys") {
            setCurrentMenuName("apiKeys");
            setCurrentActiveMenu("/apiKeys");
        }
        else if (window.location.pathname.toLowerCase() === "/billing-usage" || window.location.pathname.toLowerCase() === "/plans") {
            setCurrentMenuName("billingusage");
            setCurrentActiveMenu("/billing-usage");
        }
        else if (window.location.pathname.toLowerCase() === "/callanalysis") {
            setOpen(true);
            setCurrentMenuName("showMoreLess");
            setCurrentSubMenuName("callanalysis");
            setCurrentActiveMenu(`/callanalysis`)
        }
        else if (window.location.pathname.toLowerCase() === "/callanalysis/callrecords") {
            setOpen(true);
            setCurrentMenuName("showMoreLess");
            setCurrentSubMenuName("callanalysis");
            setCurrentActiveMenu(`/callanalysis/callrecords`)
        }
        else if (window.location.pathname.toLowerCase() === "/callanalysis/callrecords/newcallrecords") {
            setOpen(true);
            setCurrentMenuName("showMoreLess");
            setCurrentSubMenuName("callanalysis");
            setCurrentActiveMenu(`/callanalysis/callrecords/newcallrecords`)
        }
        else if (customPagesData && customPagesData?.length > 0 && customPagesData?.find((pages) => pages.custom_page_slug == window.location.pathname)) {
            setOpen(true);
            setCurrentMenuName("userdashboard")
            setCurrentSubMenuName(customPagesData?.find((pages) => pages.custom_page_slug == window.location.pathname)?.custom_page_name?.toLowerCase() || "")
            setCurrentActiveMenu(customPagesData?.find((pages) => pages.custom_page_slug == window.location.pathname)?.custom_page_slug || "")
        }
        // else if (window.location.pathname.toLowerCase() === "/callanalysis") {
        //     setCurrentMenuName("dashboard");
        //     // setCurrentSubMenuName("");
        //     setCurrentActiveMenu(`/callanalysis`)
        // }
        // else if (window.location.pathname.toLowerCase() === "/callanalysis/list") {
        //     setCurrentMenuName("callanalysis");
        //     // setCurrentSubMenuName("");
        //     setCurrentActiveMenu(`/callanalysis/list`)
        // }
        else {
            setCurrentMenuName("")
            setCurrentActiveMenu(window.location.pathname.toLowerCase())
        }
    }, [window.location.pathname])

    const handleClick = (keyName: string) => {
        setOpen(true)
        if (!selectedSubMenu.includes(keyName)) {
            setSelectedSubMenu([...selectedSubMenu, keyName]);
        }
        else if (selectedSubMenu.includes(keyName)) {
            setSelectedSubMenu([...selectedSubMenu.filter((data) => data !== keyName)])
        }
        if (window.location.pathname.toLowerCase() === `/chatbot/viewchatbot/channels/website` || window.location.pathname.toLowerCase() === `/chatbot/viewchatbot/channels/slack` || window.location.pathname.toLowerCase().includes('/chatbot/viewchatbot/channels/calendly') || window.location.pathname.toLowerCase() === `/chatbot/viewchatbot/channels/whatsapp` || window.location.pathname.toLowerCase() === `/chatbot/viewchatbot/channels/facebook` || window.location.pathname.toLowerCase() === `/chatbot/viewchatbot/channels/viewwhatsappintegration` || window.location.pathname.toLowerCase() === `/chatbot/viewchatbot/channels/viewfacebookintegration`) {
            setOpen(true);
        }
        else if (window.location.pathname.toLowerCase() === `/callanalysis` || window.location.pathname.toLowerCase() === `/callanalysis/callrecords` || window.location.pathname.toLowerCase() === `/callanalysis/callrecords/newcallrecords`) {
            setOpen(true);
        }
        else if (customPagesData && customPagesData.length > 0 && customPagesData.filter((data) => data.custom_page_name == currentMenuName).length > 0) {
            setOpen(true);
        }
        else {
            // setOpen(!open);
        }
    };

    const useStyles = makeStyles(() => ({
        customTooltip: {
            // backgroundColor: '#EFD7FE',
            backgroundColor: tertiaryColor,
            color: primaryColor,
            fontSize: '13px',
            padding: '8px 15px',
            borderRadius: 5,
        },
        customSubTooltip: {
            backgroundColor: '#FFF',
            color: '#4C4A4D',
            boxShadow: "0px 0px 3px rgba(0,0,0,0.3)",
            fontSize: '13px',
            padding: '0px 11px',
            borderRadius: 5,
        },
        customArrow: {
            // color: '#EFD7FE',
            color: tertiaryColor
        },
        customSubArrow: {
            color: 'rgba(0,0,0,0.25)',
        },
    }));
    const classes = useStyles();

    const handleLogoClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        if (isNewTabClick(event)) return;
        event.preventDefault();
        navigate("/");
    };

    const drawer = (
        <>
            <Grid container className={`${styles.mobiledrawerContainer} ${getSideNavigationPanelMaxHeightClassName(pathName, userDetail, 'desktop')} ${styles.navigationPanelContentWrapper}`} mt={1}>
                <Grid item> 
                    {flagShowGetStartedPage(userDetail) &&
                        <>
                            <Grid item
                                component="a"
                                href="/get-started"
                                className={`${isGetStartedPageActive() ? styles.getStartedPageBlockWithActivePage : styles.getStartedPageBlockWithoutActive} ${globalStyles.clickable} ${styles.navigationLink}`}
                                onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
                                    if (isNewTabClick(event)) return;
                                    event.preventDefault();
                                    navigate("/get-started");
                                }}
                            >
                                <Grid container className={styles.getStartedPageBlockContainer}>
                                    <Grid item className={globalStyles.displayFlexStyle}>
                                        <IconsColor iconName="getStartedPageIcon" height={21} width={20} fillColor={primaryColor} />
                                    </Grid>
                                    <Grid item className={styles.getStartedPgaeText}>Get Started</Grid>
                                </Grid>
                            </Grid>
                            <Divider className={styles.desktopDrawerDivider} />
                        </>
                    }
                    <List className={styles.drawerItemsPadding}  >
                        {props.menuItems.map((menuItem: any, index: any) => {

                            return (
                                <React.Fragment key={index}>
                                    {!menuItem.subMenu ?
                                        <>
                                            {menuItem.flagHeaderKey ?
                                                <Tooltip
                                                    title={menuItem.menuName}
                                                    arrow
                                                    placement="right"
                                                    classes={{ tooltip: classes.customTooltip, arrow: classes.customArrow }}
                                                    className={styles.drawerTooltipWrapper}
                                                >

                                                    <ListItem
                                                        component="a"
                                                        // Header items only navigate for "Get Started"
                                                        href={menuItem?.menuName?.toLowerCase() == "get started" ? menuItem.navigationLink : undefined}
                                                        sx={{ opacity: menuItem.flagDisabled ? "0.5" : "1" }}
                                                        className={`${styles.headerSideItem} ${styles.navigationLink}`} onMouseEnter={() => { setHoveredMenu(menuItem.menuKey) }} onMouseLeave={() => { setHoveredMenu("") }}
                                                        onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
                                                            if (isNewTabClick(event)) return;
                                                            event.preventDefault();
                                                            setCurrentSubMenuName("")
                                                            if(menuItem?.menuName?.toLowerCase() == "get started"){
                                                                setCurrentMenuName(menuItem.menuKey)
                                                                navigate(menuItem.navigationLink)
                                                            }
                                                        }}
                                                        key={menuItem.menuKey} disablePadding>

                                                        <ListItemIcon className={styles.imageNavigationMenu}>
                                                            {
                                                                currentMenuName == menuItem.menuKey ? menuItem.whiteImgSrc : hoveredMenu.toLowerCase() == menuItem.menuKey.toLowerCase() ? menuItem.coloredImgSrc : menuItem.imgSrc}
                                                        </ListItemIcon>
                                                        <ListItemText primary={menuItem.menuName} className={`${
                                                            currentMenuName == menuItem.menuKey || menuItem.flagDisabled || menuItem.flagHeaderKey ? styles.listItemSelectedMenuText : styles.listItemMenuText}`} />

                                                    </ListItem>
                                                </Tooltip>
                                                :
                                                <ListItem
                                                    component="a"
                                                    href={!menuItem.flagDisabled && !menuItem.flagHeaderKey ? menuItem.navigationLink : undefined}
                                                    sx={{ opacity: menuItem.flagDisabled ? "0.5" : "1" }}
                                                    className={`${menuItem.flagHeaderKey ? styles.headerSideItem :
                                                        currentMenuName == menuItem.menuKey ? styles.selectedListItemStyle : styles.listItemStyle} ${styles.navigationLink}`} onMouseEnter={() => { setHoveredMenu(menuItem.menuKey) }} onMouseLeave={() => { setHoveredMenu("") }}
                                                    onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
                                                        if (isNewTabClick(event)) return;
                                                        event.preventDefault();
                                                        if (menuItem.flagDisabled) {
                                                        } else if (menuItem.flagHeaderKey) {
                                                            setCurrentSubMenuName("");
                                                        } else {
                                                            setSelectedSubMenu([])
                                                            setCurrentSubMenuName("");
                                                            // setCurrentActiveMenu(menuItem.navigationLink);
                                                            setCurrentMenuName(menuItem.menuKey)
                                                            navigate(menuItem.navigationLink)
                                                        }
                                                    }}
                                                    key={menuItem.menuKey} disablePadding>
                                                    <ListItemIcon className={styles.imageNavigationMenu}>
                                                        {
                                                            currentMenuName == menuItem.menuKey ? menuItem.whiteImgSrc : hoveredMenu.toLowerCase() == menuItem.menuKey.toLowerCase() ? menuItem.coloredImgSrc : menuItem.imgSrc}
                                                    </ListItemIcon>
                                                    <ListItemText primary={menuItem.menuName} className={
                                                        currentMenuName == menuItem.menuKey || menuItem.flagDisabled || menuItem.flagHeaderKey ? styles.listItemSelectedMenuText : styles.listItemMenuText} />

                                                    {menuItem.flagAdmin &&
                                                        <AdminPanelSettingsIcon />
                                                    }
                                                </ListItem>
                                            }
                                        </>
                                        :
                                        <>
                                            <ListItem button onClick={() => handleClick(menuItem.menuKey)} className={currentMenuName == menuItem.menuKey && !selectedSubMenu.includes(menuItem.menuKey) ? styles.selectedListItemStyle : styles.listItemStyle}>
                                                {menuItem.menuName?.toLowerCase() != "show more/less" ?
                                                    <ListItemIcon className={`${styles.imageNavigationMenu} ${styles.scaledLarge}`}>
                                                        {menuItem.imgSrc}
                                                    </ListItemIcon>
                                                    :
                                                    <ListItemIcon className={`${styles.imageNavigationMenu}`}>
                                                        {open && selectedSubMenu.includes(menuItem.menuKey) ? <ExpandLess sx={{ marginLeft: "-4px", color: "#4C4A4D" }} /> : <ExpandMore sx={{ marginLeft: "-4px", color: "#4C4A4D" }} />}        
                                                    </ListItemIcon>
                                                }
                                                <ListItemText primary={getMenuNameOfMainMenu(menuItem.menuName, open && selectedSubMenu.includes(menuItem.menuKey))} /> 

                                                {menuItem.menuName?.toLowerCase() != "show more/less" && 
                                                    <>
                                                        {open && selectedSubMenu.includes(menuItem.menuKey) ? <ExpandLess sx={{ marginRight: "6px", color: "#4C4A4D" }} /> : <ExpandMore sx={{ marginRight: "6px", color: "#4C4A4D" }} />}
                                                    </>
                                                }
                                            </ListItem>
                                            <Collapse in={open && selectedSubMenu.includes(menuItem.menuKey)} timeout="auto" unmountOnExit>
                                                <List component="div" disablePadding>
                                                    {/* Nested items */}
                                                    {menuItem.subMenu.map((subMenu: any, ind: number) => {
                                                        return <ListItem
                                                            component="a"
                                                            href={!subMenu.flagDisabled ? subMenu.navigationLink : undefined}
                                                            sx={{ opacity: subMenu.flagDisabled ? "0.5" : "1", paddingLeft: "10px !important" }}
                                                            className={`${
                                                                currentSubMenuName === subMenu.menuKey ? styles.selectedListItemStyle : styles.listItemStyle} ${styles.navigationLink}`}
                                                            onMouseEnter={() => { setHoveredMenu(subMenu.menuKey) }}
                                                            onMouseLeave={() => { setHoveredMenu("") }}
                                                            onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
                                                                if (isNewTabClick(event)) return;
                                                                event.preventDefault();
                                                                if (!subMenu.flagDisabled) {
                                                                    setCurrentActiveMenu(subMenu.navigationLink);
                                                                    setCurrentSubMenuName(subMenu.menuKey);
                                                                    setCurrentMenuName(menuItem.menuKey)
                                                                    // if (!subMenu.flagUserSpecific) {
                                                                    navigate(subMenu.navigationLink);
                                                                    // }
                                                                    // onClose();
                                                                }
                                                            }}
                                                            key={ind}
                                                            disablePadding
                                                        >
                                                            <ListItemIcon className={`${styles.imageNavigationMenu} ${styles.scaledLarge}`}>
                                                                {
                                                                    currentSubMenuName === subMenu.menuKey ? subMenu.whiteImgSrc : hoveredMenu.toLowerCase() == subMenu.menuKey.toLowerCase() ? subMenu.coloredImgSrc : subMenu.imgSrc}
                                                            </ListItemIcon>
                                                            <ListItemText primary={subMenu.menuName} className={
                                                                currentSubMenuName === subMenu.menuKey || menuItem.flagDisabled || menuItem.flagHeaderKey ? styles.listItemSelectedMenuText : styles.listItemMenuText} />
                                                            {menuItem.flagAdmin &&
                                                                <AdminPanelSettingsIcon />
                                                            }
                                                        </ListItem>
                                                    })
                                                    }
                                                </List>
                                            </Collapse>
                                        </>
                                    }
                                </React.Fragment>
                            )
                        })}
                    </List>
                </Grid>
                <Grid item>
                    <Grid container direction={"column"}>
                        {
                            <Grid item className={`${styles.profileWrapper}`}>
                                <DelegateAccess />
                            </Grid>
                        }
                        {/* <Grid item className={styles.settingsWorkspace}>
                            <SettingsWorkspace />
                        </Grid> */}
                        {!sideNavigationNavigateToHomeBlockedRoutes(window.location.pathname) &&
                            <Grid item
                                className={styles.backToHomeButton}
                            >
                                <BackToMainPageGlobalComponent />
                            </Grid>
                        }
                        {/* {!userDetail.flag_user_anonymous &&
                            userDetail.flagUser &&
                            <Grid item className={`${styles.profileWrapper}`}>
                                <ConsultationComponent flagInsideSideNavigationPanel />
                            </Grid>
                        } */} 
                        {
                            showWorkspaceBlock(pathName) &&
                            <>
                                <Grid item className={`${styles.workspaceWrapper} ${styles.workSpaceAnimationStyle}`}>
                                    <Grid container className={styles.workspaceContainer}  >
                                        <Grid item>
                                            <Grid container className={`${styles.workspaceTextContainer} ${styles.workspaceTextGap}`}>
                                                <Grid item><IconsColor height={"15"} width={"15"} fillColor={"#4C4A4D"} iconName="workspace" /></Grid>
                                                <Grid item className={styles.workspaceText} ><span>Workspace</span></Grid>
                                            </Grid>
                                        </Grid>
                                        {organizationDetails && organizationDetails.length > 1 ?
                                            <Autocomplete
                                                disableClearable
                                                value={organizationDetails ? organizationDetails.find((organization) => organization.organization_status_name === "Active") : undefined}
                                                className={`${globalStyles.chatbotTitleSelect}`}
                                                options={organizationDetails ? organizationDetails : []}
                                                getOptionLabel={(option: getOrganizationDetailDataModel) => option.organization_name}
                                                // onChange={(e, value) => handleOptionChange(e, value)}
                                                renderInput={(params) => <TextField
                                                    {...params} placeholder='Select' />}
                                            />
                                            :
                                            <Grid item className={styles.organizationName}>
                                                {organizationDetails ? organizationDetails[0].organization_name : ""}
                                            </Grid>}
                                    </Grid>
                                </Grid> 
                                {/* {!props.menuItems.find((menu: any) => (!menu?.subMenu && menu?.flagHeaderKey)) && 
                                    <Divider className={styles.desktopDrawerDivider} />
                                } */}
                            </>
                        }
                        <Grid item className={styles.profileWrapper}>
                            <SidepanelAccountDetails />
                        </Grid>
                    </Grid>
                </Grid>

            </Grid>
        </>

    );


    const minimizedDrawer = (
        <> 
            {flagShowGetStartedPage(userDetail) && 
                <>
                    <List className={styles.miniDrawerPaddingForGetStarted}>
                        <Tooltip
                            title="Get Started"
                            arrow
                            placement="right" 
                            classes={{ tooltip: isGetStartedPageActive()  ? classes.customSubTooltip : classes.customTooltip, arrow: isGetStartedPageActive() ? classes.customSubArrow : classes.customArrow }}
                        >
                            <ListItem sx={{ display: "flex", justifyContent: "center", alignItems: "center", transform: "scale(1.2)" }}
                                component="a"
                                href="/get-started"
                                className={`${isGetStartedPageActive() ? styles.selectedListItemStyle : styles.listItemStyle} ${styles.navigationLink}`}
                                onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
                                    if (isNewTabClick(event)) return;
                                    event.preventDefault();
                                    navigate("/get-started");
                                }}
                                disablePadding
                            >
                                <ListItemIcon className={styles.mobileImageNavigationMenu}>
                                    <IconsColor iconName="getStartedPageIcon" height={21} width={20} fillColor={primaryColor} />
                                </ListItemIcon>
                            </ListItem>
                        </Tooltip>
                    </List>
                </>
            }
            <Grid container className={`${styles.navigationPanelContentWrapper} ${getSideNavigationPanelMaxHeightClassName(pathName, userDetail, 'desktop')} ${globalStyles.columnSpaceBetween}`}>
                <Grid item>
                    <List className={styles.miniDrawerPadding}>
                        {props.menuItems.map((menuItem: any, index: any) => {
                            return <Tooltip
                                key={index}
                                title={!menuItem.subMenu ? menuItem.menuName
                                    :
                                    <>
                                        {
                                            tooltipClickedMenu === menuItem.menuName ?
                                                <>
                                                    <List sx={{ padding: '10px', paddingBottom: "1px", fontSize: "10px" }} >
                                                        {menuItem.subMenu.map((menuSubItem: any, index: any) => {
                                                            return <Tooltip key={index} title={""} arrow placement="right" classes={{ tooltip: classes.customTooltip, arrow: classes.customArrow }} className={styles.drawerTooltipWrapper}>
                                                                <ListItem sx={{ display: "flex", justifyContent: "center", alignItems: "center", opacity: menuSubItem.flagDisabled ? "0.5" : "1", transform: "scale(1.2)", cursor: "pointer", width: "100%" }} className={`${
                                                                    currentSubMenuName == menuSubItem.menuKey ? styles.SelectedListSubItemStyle : styles.listSubItemStyle} ${styles.navigationLink}`} onMouseEnter={() => { setHoveredMenu(menuSubItem.menuKey) }} onMouseLeave={() => { setHoveredMenu("") }}
                                                                    component="a"
                                                                    href={!menuSubItem.flagDisabled ? menuSubItem.navigationLink : undefined}
                                                                    onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
                                                                        if (isNewTabClick(event)) return;
                                                                        event.preventDefault();
                                                                        if (menuSubItem.flagDisabled) {
                                                                        } else {
                                                                            setCurrentActiveMenu(menuSubItem.navigationLink);
                                                                            setCurrentMenuName(menuItem.menuKey);
                                                                            setCurrentSubMenuName(menuSubItem.menuKey)
                                                                            // if (!menuSubItem.flagUserSpecific) {
                                                                            navigate(menuSubItem.navigationLink);
                                                                            // }
                                                                            setTooltipClickedMenu("")
                                                                        }
                                                                    }}
                                                                    key={menuSubItem.menuKey}>
                                                                    <ListItemIcon className={styles.imageSubNavigationMenu} sx={{ minWidth: '10px' }}>
                                                                        {
                                                                            currentSubMenuName == menuSubItem.menuKey ? menuSubItem.whiteImgSrc : hoveredMenu.toLowerCase() == menuSubItem.menuKey.toLowerCase() ? menuSubItem.coloredImgSrc : menuSubItem.imgSrc}
                                                                    </ListItemIcon>
                                                                    <ListItemText className={styles.subMenuHoverItems} primary={menuSubItem.menuName} sx={{ paddingLeft: '0px' }} />
                                                                </ListItem>
                                                            </Tooltip>
                                                        })}
                                                    </List>
                                                </>
                                                :
                                                <>
                                                    {getMenuNameOfMainMenu(menuItem.menuName, false)}
                                                </>
                                        }

                                    </>
                                }
                                arrow
                                placement="right" classes={{ tooltip: tooltipClickedMenu === menuItem.menuName ? classes.customSubTooltip : classes.customTooltip, arrow: tooltipClickedMenu === menuItem.menuName ? classes.customSubArrow : classes.customArrow }}>
                                <ListItem sx={{ display: "flex", justifyContent: "center", alignItems: "center", opacity: menuItem.flagDisabled ? "0.5" : "1", transform: "scale(1.2)" }} className={`${menuItem.flagHeaderKey ? styles.headerSideMobileItem :
                                    currentMenuName == menuItem.menuKey ? styles.selectedListItemStyle : styles.listItemStyle} ${styles.navigationLink}`} onMouseEnter={() => { setHoveredMenu(menuItem.menuKey) }} onMouseLeave={() => { setHoveredMenu("") }}
                                    component="a"
                                    // Items with a sub menu only open their sub menu, so they are not links
                                    href={!menuItem.flagDisabled && !menuItem.subMenu && !menuItem.flagHeaderKey ? menuItem.navigationLink : undefined}
                                    onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
                                        if (isNewTabClick(event)) return;
                                        event.preventDefault();
                                        if (menuItem.flagDisabled) {
                                        } else if (menuItem.subMenu) {
                                            setTooltipClickedMenu(menuItem.menuName);
                                        } else if (menuItem.flagHeaderKey) {
                                            setTooltipClickedMenu("")
                                            setCurrentSubMenuName("")
                                        } else {
                                            setCurrentActiveMenu(menuItem.navigationLink);
                                            setCurrentMenuName(menuItem.menuKey);
                                            navigate(menuItem.navigationLink);
                                            setTooltipClickedMenu("")
                                            setCurrentSubMenuName("")
                                        }
                                    }}
                                    key={menuItem.menuKey} disablePadding>
                                    <ListItemIcon className={styles.mobileImageNavigationMenu}>
                                        {
                                            currentMenuName === menuItem.menuKey ? menuItem.whiteImgSrc : hoveredMenu.toLowerCase() == menuItem.menuKey.toLowerCase() ? menuItem.coloredImgSrc : menuItem.imgSrc}
                                    </ListItemIcon>
                                </ListItem>
                            </Tooltip>
                        })}
                    </List>
                </Grid>
                <Grid item>
                    <Grid container direction={"column"} className={globalStyles.containerflexWrapStyle}>
                        {
                            <Grid item className={`${styles.profileWrapper}`}>
                                <DelegateAccess flagMobile />
                            </Grid>
                        }
                        {/* <Grid item>
                            <SettingsWorkspace flagMobile />
                        </Grid> */}

                        {!sideNavigationNavigateToHomeBlockedRoutes(window.location.pathname) &&
                            <Grid item>
                                <BackToMainPageGlobalComponent flagMobile />
                            </Grid>
                        }
                        {/* {!userDetail.flag_user_anonymous &&
                            userDetail.flagUser &&
                            <Grid item className={`${styles.profileWrapper}`}>
                                <ConsultationComponent flagMobile flagInsideSideNavigationPanel />
                            </Grid>
                        } */} 
                        {
                            (showWorkspaceBlock(pathName)) &&
                            <>
                                <Menu
                                    anchorEl={anchorEl}
                                    // className={MenuPaper}
                                    id="workspace-menu"
                                    open={openMenu}
                                    onClose={handleClose}
                                    onClick={handleClose}
                                    className={`${styles.settingsStyleSidePanel} ${globalStyles.aboveGlobalLoader}`}
                                    PaperProps={{
                                        elevation: 0,
                                        sx: {
                                            overflow: 'visible',
                                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                            mt: 1.5,
                                            '& .MuiAvatar-root': {
                                                width: 32,
                                                height: 32,
                                                ml: -0.5,
                                                mr: 1,
                                            },
                                        },
                                    }}
                                    transformOrigin={{ horizontal: 'left', vertical: 'center' }}
                                    anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                                >
                                    {
                                        organizationDetails && organizationDetails.map((organization, ind) => <MenuItem key={ind} className={organization.organization_status_name === "Active" ? styles.activeWorkspaceMenu : styles.inActiveWorkspaceMenu}>
                                            {organization.organization_name}
                                        </MenuItem>)
                                    }
                                </Menu>
                                <Grid item className={styles.miniDrawerWorkspaceWrapper}>
                                    <Grid container className={styles.workspaceContainer}>
                                        <Grid item>
                                            <Grid container className={styles.workspaceTextContainer}>
                                                <Grid item
                                                    sx={{ display: "flex" }}
                                                    onClick={handleClickWorkspace}
                                                    aria-controls={openMenu ? 'workspace-menu' : undefined}
                                                    aria-haspopup="true"
                                                    aria-expanded={openMenu ? 'true' : undefined}
                                                // sx={{ cursor: "pointer", fontSize: "medium !important", color: "#7A7A7A !important" }}
                                                >
                                                    <IconsColor height={"20"} width={"20"} fillColor={"#4C4A4D"} iconName="workspace" />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {/* <Divider className={styles.miniDrawerDividerPadding} /> */}
                            </>
                        }
                        <Grid item className={styles.profileWrapper}>
                            <SidepanelAccountDetails flagMobile />
                        </Grid>
                    </Grid>
                </Grid>

            </Grid>
        </>

    );
    return (
        <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <Drawer className={styles.sideNavigationPanelStyle} variant="permanent" open={props.open}>
                <DrawerHeader>
                    <Grid container className={styles.drawerHeaderContainer}   >
                        {props.open ? (
                            <>
                                <Grid item>
                                    <a href="/" className={`${styles.navigationLink} ${styles.logoLink}`} onClick={handleLogoClick}>
                                        <img
                                            alt="logo"
                                            src={getVendorField(vendorData, "company primary logo", chronoxLogo)}
                                            className={`${styles.writewizLogoStyle} ${globalStyles.clickable}`} // Keeping the existing class and adding a new one
                                        />
                                    </a>
                                </Grid>
                                
                                {isStagingEnv() && (
                                    <span className={styles.devBadge}>
                                        Dev
                                    </span>
                                )}
                            </>
                        ) : (
                            <Grid item>
                                <a href="/" className={`${styles.navigationLink} ${styles.logoLink}`} onClick={handleLogoClick}>
                                    <img
                                        alt="logo"
                                        src={getVendorField(vendorData, "company primary logo favicon", shortChronoxLogo)}
                                        className={`${styles.writewizLogoStyle} ${styles.newCollapsedLogo}`} // Keeping the existing class and adding a new one
                                    />
                                </a>
                            </Grid>
                        )}
                    </Grid>

                </DrawerHeader>
                {props.open ? drawer : minimizedDrawer}
            </Drawer>
        </Box>
    );
}
